// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3teoX","options":"AnswerScale_options__2YjUa","selected":"AnswerScale_selected__1ImUG"};